define.alias("shared/components/shared/profile-categorization/loading", "calendar/components/shared/profile-categorization/loading");